import {LayerController} from './layer.controller';
import {Layer} from '../../shared/models/layer.model';
import {Page} from '../../shared/models/page.model';
import {Injector} from '@angular/core';
import {Marker} from '../../shared/models/map/marker.model';
import {NGSIResult} from '../../shared/models/ngsi/ngsi-result';

export class SportsFacilityLayerController extends LayerController {
  displaysTooltip: boolean = true;
  constructor(layer: Layer, page: Page, private injector: Injector) {
    super(layer, page, injector);
  }

  protected getDialogContext(result: NGSIResult): any {
  }


  createTooltip(marker: Marker): string {

    const name = marker.entity.getSingleElementValue('name');
    const city = marker.entity.getSingleElementValue('city');


    let html = '<div class="entity-tooltip">';
    html += `<div class="text"><span class="title">Spor Tesisi :  </span> ${name} </div>`;
    html += `<div class="text"><span class="title">Şehir : </span> ${city} </div>`;
    html += '</div>';

    return html;
  }

}
